<template>
  <div>
    <v-container fluid pa-0>
      <v-layout row wrap justify-space-between align-end class="datSectionTitleBg px-4 py-5">
        <v-flex xs12 sm6 class="datSectionTitle">
          {{ $t('informes') }}
          <v-breadcrumbs divider="/" class="pa-0">
            <v-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :disabled="item.disabled">
              {{ item.text }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field color="datPrimary" class="my-0 py-0" append-icon="search" @click:append="buscar"
            v-model="dSearchInformes" :label="$t('buscar')"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid mb-5 pa-0>
      <v-layout row wrap class="px-2 contentBg">
        <v-flex xs12 sm6 md4 lg3 class="pt-0 px-3" v-for="(informe, index) in informes" v-bind:key="index">
          <v-card flat class="businessAreaContainer">
            <v-card-title class="pa-0">
              <v-icon class="businessAreaIcon shrink mx-auto">{{ informe.ico }}</v-icon>
              <v-flex xs12 class="pt-5 businessAreaCard text-xs-center">
                <p v-if="informe.nombre === 'VENTAS POR REPRESENTANTE/CLIENTE/MES'" class="businessAreaTitle mb-1">
                  {{ this.$t('ventasXRepresentateCliMes') }}</p>
                <p v-else class="businessAreaTitle text-xs-center mb-1">{{ informe.nombre }}</p>
                <span>{{ informe.descripcion }}</span>
                <v-flex text-xs-center>
                  <v-btn class="datPrimaryBtn" :id="'informe_' + informe.informe" flat
                    @click.stop="abrirInforme(informe)" v-html="dAbrirTxt"></v-btn>
                </v-flex>
              </v-flex>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <shp-filtro-report-estado-pedidos @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ESTADO_PED_ALB' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" :paramsPedidos="dParamsPedidos" />
    <shp-filtro-estado-ventas @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ESTADO_VENTAS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <shp-estadisticas-ventas @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ESTADIST_VENTAS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <shp-reimpresion-facturas @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'REIMP_FACT' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" :paramsReimpresionFacturas="dParamsReimpresionFacturas" />
    <ShpFiltroCobrosPendientes @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading" 
      v-if="dInformeSeleccionado.informe === 'IMPAGADOS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <shp-filtro-estado-vencimientos @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ESTADO_VENCI' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <shp-filtro-riesgos @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'RIESGOS' && mostrarDialogInforme"
      :pInformeComponente="dInformeSeleccionado" />
    <shp-estadisticas-prov-repre @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ESTAD_PROV_REP' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" @closed="mostrarDialogInforme = false" />
      <shp-filtro-estado-recogidas @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ENTR_REC_TRANS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <shp-certificado-ambiental @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'CERT_MEDIOAMB' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <ShpPresupuestos @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'PRESUPUESTOS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <ShpComprasVentas @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'COMPRAS_VENTAS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <ShpFacturasClientes @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'FACT_CLIENTES' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <ShpAlbaranesProveedor @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'ALB_PROV' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <ShpContTratamientos @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'CONT_TRAT' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
    <ShpFacturasProveedor @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'FACT_PROV' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
      <ShpStockArticulos @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'STOCK_ARTICULOS' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
      <ShpOCPendientes @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading"
      v-if="dInformeSeleccionado.informe === 'OC_PENDIENTES' && mostrarDialogInforme" :pLimitDate="dFechas"
      :pInformeComponente="dInformeSeleccionado" />
      <!-- EQuery se activó para una demo de AZZAR, se mantendrá comentado por si en un futuro se desea hacer otra demo. Descomentar tambien línea 305 
     "<ShpEQuery @close="fCloseDialogs" @alert="fEventAlert" @loading="fLoading" v-if="dInformeSeleccionado.informe === 'EQUERY' && mostrarDialogInforme" :pLimitDate="dFechas" :pInformeComponente="dInformeSeleccionado" /> "-->
    <ScreenLoading ref="DatDialog"></ScreenLoading>
  </div>
</template>

<script>
import ShpFiltroReportEstadoPedidos from '@/components/Informes/Pedidos/ShpFiltroReportEstadoPedidos'

// SERVICIOS
import SrvGeneral from '@/services/srv-general'
import SrvFechasRoles from '@/services/srv-fechas-roles'
import SrvUsers from '@/services/srv-users'

// COMPONENTES
// - Informes antiguos
import ShpFiltroEstadoVentas from '@/components/Informes/Pedidos/ShpFiltroEstadoVentas'
import ShpEstadisticasVentas from '@/components/Informes/Estadisticas/ShpEstadisticasVentas'
import ShpReimpresionFacturas from '@/components/Informes/ReimpresionFacturas/ShpReimpresionFacturas'
import ShpFiltroCobrosPendientes from '@/components/Informes/Cobros/ShpFiltroCobrosPendientes'
import ShpFiltroEstadoVencimientos from '@/components/Informes/Cobros/ShpFiltroEstadoVencimientos'
import ShpFiltroRiesgos from '@/components/Informes/Riesgos/ShpFiltroRiesgos'
import ShpEstadisticasProvRepre from '@/components/Informes/Estadisticas/ShpEstadisticasProvRepre'
import ShpCarteraClientes from '@/components/Informes/CarteraClientes/ShpCarteraClientes'
import ShpContTratamientos from '@/components/Informes/Tratamientos/ShpContTratamientos'
import ShpStockArticulos from '@/components/Informes/StockArticulos/ShpStockArticulos'
import ShpOCPendientes from '@/components/Informes/OCPendientes/ShpOCPendientes'

import ShpFacturasProveedor from '@/components/Informes/ReimpresionFacturas/ShpFacturasProveedor'
import ShpEQuery from '@/components/ShpEQuery'

// - Residuos
import ShpFiltroEstadoRecogidas from '@/components/Informes/EstadoRecogidas/ShpFiltroEstadoRecogidas'
import ShpCertificadoAmbiental from '@/components/Informes/CertAmbiental/ShpCertificadoAmbiental'
import ShpComprasVentas from '@/components/Informes/ComprasVentas/ShpComprasVentas'
import ShpFacturasClientes from '@/components/Informes/ReimpresionFacturas/ShpFacturasClientes'
import ShpAlbaranesProveedor from '@/components/Informes/Albaranes/ShpAlbaranesProveedor'

// - Presupuestos
import ShpPresupuestos from '@/components/Informes/Presupuestos/ShpPresupuestos'

// Implementamos el servicio de las fechas por Roles, para pasarla a todos los demás componentes.
import ScreenLoading from '@/components/Generales/ScreenLoading'

export default {
  components: {
    ShpFiltroReportEstadoPedidos,
    ShpFiltroEstadoVentas,
    ShpEstadisticasVentas,
    ShpReimpresionFacturas,
    ShpFiltroCobrosPendientes,
    ShpFiltroEstadoVencimientos,
    ShpFiltroRiesgos,
    ShpEstadisticasProvRepre,
    ShpFiltroEstadoRecogidas,
    ShpCertificadoAmbiental,
    ShpCarteraClientes,
    ScreenLoading,
    ShpPresupuestos,
    ShpComprasVentas,
    ShpFacturasClientes,
    ShpContTratamientos,
    ShpStockArticulos,
    ShpOCPendientes,
    ShpAlbaranesProveedor,
    ShpFacturasProveedor,
    ShpEQuery
  },
  data() {
    return {
      dateTemp: '2020-10-25T23:00:00.000Z',
      dDateForma: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },

      dAbrirTxt: this.$t('abrir'),
      dSearchInformes: '',
      idRol: 0,
      dMostrarEvento: 'evento-mostrarAvisos',
      dFechas: { 'fechaIniLimit': '', 'fechaFinLimit': '', 'diasAntiguedad': '', 'roleUser': '', 'autoFiltro': false },
      dInformeSeleccionado: { informe: '' },
      mostrarDialogInforme: false,
      informesUsuario: [],
      informesBase: [
        { informe: 'ESTADO_PED_ALB', ico: 'mdi-clipboard-text-outline', nombre: this.$t('estadoPedidosAlbaran'), descripcion: this.$t('estadoPedidosAlbaranDesc'), visible: false },
        { informe: 'ESTADO_VENTAS', ico: 'mdi-truck-check-outline', nombre: this.$t('estadoVentas'), descripcion: this.$t('estadoVentasDesc'), visible: false },
        { informe: 'ESTADIST_VENTAS', ico: 'mdi-truck-outline', nombre: this.$t('estadisticasVentas'), descripcion: this.$t('estadisticasVentasDesc'), visible: false },
        { informe: 'REIMP_FACT', ico: 'mdi-file-document-outline', nombre: this.$t('reimpresionFacturas'), descripcion: this.$t('reimpresionFacturasDesc'), visible: false },
        { informe: 'ESTADO_VENCI', ico: 'mdi-calendar-clock', nombre: this.$t('estadoVencimientos'), descripcion: this.$t('estadoVencimientosDesc'), visible: false },
        { informe: 'IMPAGADOS', ico: 'mdi-cash', nombre: this.$t('impagados'), descripcion: this.$t('impagadosDesc'), visible: false },
        { informe: 'RIESGOS', ico: 'mdi-account-cash-outline', nombre: this.$t('riesgos'), descripcion: this.$t('riesgosDesc'), visible: false },
        { informe: 'ESTAD_PROV_REP', ico: 'mdi-file-chart-outline', nombre: this.$t('estProvRepre'), descripcion: this.$t('estProvRepreDesc'), visible: false },
        { informe: 'ENTR_REC_TRANS', ico: 'mdi-recycle', nombre: this.$t('recEntrTran'), descripcion: this.$t('recEntrTranDesc'), visible: false },
        { informe: 'CERT_MEDIOAMB', ico: 'mdi-certificate', nombre: this.$t('certMed'), descripcion: this.$t('certMedDesc'), visible: false },
        { informe: 'CARTERA_CLIENTS', ico: 'mdi-folder-account', nombre: this.$t('userFolder'), descripcion: this.$t('userFolderDesc'), visible: false },
        { informe: 'PRESUPUESTOS', ico: 'mdi-folder-account', nombre: this.$t('presupuestos'), descripcion: this.$t('presupuestosDesc'), visible: false },
        { informe: 'COMPRAS_VENTAS', ico: 'mdi-cash-multiple', nombre: this.$t('comprasVentas'), descripcion: this.$t('comprasVentasDesc'), visible: false },
        { informe: 'FACT_CLIENTES', ico: 'mdi-file-table-outline', nombre: this.$t('factClte'), descripcion: this.$t('factClteDesc'), visible: false },
        { informe: 'ALB_PROV', ico: 'mdi-briefcase-account-outline', nombre: this.$t('albProv'), descripcion: this.$t('albProvDesc'), visible: false },
        { informe: 'CONT_TRAT', ico: 'mdi-file-document-edit-outline', nombre: this.$t('contTratamientos'), descripcion: this.$t('contTratamientosDesc'), visible: false },
        { informe: 'FACT_PROV', ico: 'mdi-file-check-outline', nombre: this.$t('factProv'), descripcion: this.$t('factProvDesc'), visible: false },
        { informe: 'STOCK_ARTICULOS', ico: 'mdi-cart-outline', nombre: this.$t('stockArticulo'), descripcion: this.$t('descStockArticulo'), visible: false },
        { informe: 'OC_PENDIENTES', ico: 'mdi-receipt', nombre: this.$t('ocPendientes'), descripcion: this.$t('descOcPendientes'), visible: false },
      ],
      informes: [],
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false
        }
      ],
      timerSearchInformes: null,
      dParamsPedidos: null,
      dParamsReimpresionFacturas: null

    }
  },
  watch: {
    dSearchInformes: {
      handler() {
        clearInterval(this.timerSearchInformes)
        this.timerSearchInformes = setTimeout(() => {
          this.buscar()
        }, 500)
      }
    }
  },
  created() {
    /*
     * evento cerrado de dialogo de informes
     */
    this.cargaInformesUsuario()
    this.fGetData()
    this.fGetRole()
    this.fgetDatosUsuario()
    if (localStorage.getItem('TiendaToken') && localStorage.getItem('TiendaToken') === 'true') {
      this.dInformeSeleccionado.informe = 'ESTADO_PED_ALB'
      this.dInformeSeleccionado = {
        informe: 'ESTADO_PED_ALB',
        ico: 'mdi-clipboard-text-outline',
        nombre: this.$t('estadoPedidosAlbaran'),
        descripcion: this.$t('estadoPedidosAlbaranDesc'),
        visible: false
      }
      this.mostrarDialogInforme = true
    } else if (localStorage.getItem('ExpertToken') && localStorage.getItem('ExpertToken') === 'true') {
      this.dInformeSeleccionado.informe = 'COMPRAS_VENTAS'
      this.dInformeSeleccionado = { informe: 'COMPRAS_VENTAS', ico: 'mdi-cash-multiple', nombre: this.$t('comprasVentas'), descripcion: this.$t('comprasVentasDesc'), visible: false }
      this.mostrarDialogInforme = true
    }
  },
  methods: {
    /*
     * Obtiene la imagen de un informe
     */
    getImagen(familia) {
      return familia.imagen
    },
    fCloseDialogs() {
      this.mostrarDialogInforme = false
      this.$refs.DatDialog.fCloseDialog()
    },
    fEventAlert(msg) {
      this.$bus.$emit(this.dMostrarEvento, msg)
    },
    fLoading(msg) {
      const text = (msg || msg !== '') ? msg : ''
      this.$refs.DatDialog.fTriggerDialog(text)
    },
    /*
     * Obtiene el icono de un informe
     */
    getIcon(informe) {
      return informe.ico
    },
    /*
     * Fomate un texto a 200 caracteres
     */
    getSubString(descripcion) {
      if (descripcion.length > 200) {
        const recorte = descripcion.slice(0, 200);
        const ultimoEspacio = recorte.lastIndexOf(' ');
        return recorte.slice(0, ultimoEspacio) + '...';
      } else {
        return descripcion;
      }
    },
    /*
      Carga los datos iniciales del cliente ( FROM ADM_WEB_SELECT_DOMAIN )
    */
    fGetData() {
      const headersDomain = {
        'x-ddol-org': localStorage.getItem('headerDomain'), // Para probar en local => 'LAREDT4',
        'x-ddol-apporg': 'EPOR',
        'x-ddol-security-token': JSON.parse(localStorage.getItem('datos-autenticacion')).tira || '' // localStorage.getItem('refreshToken')
      }
      const payload = {
        'dominio': localStorage.getItem('headerDomain'), // Para probar en local => 'LAREDT4',
        'url': document.location.hostname // Para probar en local => 'ctcservicios-e-informesprep.expertxrm.com'
      }
      const promise = [];
      promise.push(
        SrvGeneral.getData(payload, headersDomain)
      )
      Promise.all(promise).then(result => {
        this.$store.commit('setUrlInfo', result[0].data)
      })
    },
    /*
     * Carga la lista de informes que puede ver el usuario
     */
    cargaInformesUsuario() {
      // prepara los parametros generales de busqueda
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion
      }
      SrvUsers.listaInformesPortal(jsonEntrada).then(response => {
        if (response.data.statusCode === '200') {
          const datosInformesUsuario = response.data
          this.informesUsuario = datosInformesUsuario.result
          this.informesUsuario.forEach((element) => {
            if (element.informe === 'ESTADO_PED_ALB' && element.parametros !== null && element.parametros !== '') {
              this.dParamsPedidos = JSON.parse(element.parametros)
            }
            if (element.informe === 'REIMP_FACT' && element.parametros !== null && element.parametros !== '') {
              this.dParamsReimpresionFacturas = JSON.parse(element.parametros)
            }
          })
          // Casa los informes con los permitidos
          this.chequeaInformesUsuario()
        } else {
          this.$bus.$emit(this.dMostrarEvento, '<b>carga los informes de portal</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.$bus.$emit(this.dMostrarEvento, '<b>carga los informes de portal</b><br> ' + error)
      })
    },
    /*
     * Comprueba los informes que puede mostrar
     */
    chequeaInformesUsuario() {
      for (let i = 0; i < this.informesBase.length; i++) {
        this.informesBase[i].visible = false
        for (let j = 0; j < this.informesUsuario.length; j++) {
          if (this.informesBase[i].informe === this.informesUsuario[j].informe) {
            this.informesBase[i].visible = true
            this.informesBase[i].url = this.informesUsuario[j].url
            this.informes.push(this.informesBase[i])
            break
          }
        }
      }
    },

    /*
     * Abre la pantalla de filtros de un informe
     */
    abrirInforme(informe) {
      this.dInformeSeleccionado = informe
      this.mostrarDialogInforme = true
    },
    /*
     * Busca los informes ue puede mostrar
     */
    buscar() {
      this.informes = []
      for (let i = 0; i < this.informesBase.length; i++) {
        if (this.informesBase[i].visible) {
          for (let j = 0; j < this.informesUsuario.length; j++) {
            if (this.informesBase[i].informe === this.informesUsuario[j].informe) {
              if ((this.informesBase[i].nombre.toUpperCase().indexOf(this.dSearchInformes.toUpperCase()) > -1) || (this.informesBase[i].descripcion.toUpperCase().indexOf(this.dSearchInformes.toUpperCase()) > -1)) {
                this.informes.push(this.informesBase[i])
                break
              }
            }
          }
        }
      }
    },
    /**
     * Se recupera el rol del cliente
     */
    fGetRole() {
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion
      }
      SrvFechasRoles.getRole(payload).then(response => {
        if (response.status === 200) {
          this.idRol = response.data.idRol
          this.dFechas.roleUser = response.data.role
          this.fGetFechas()
        }
      })
    },
    fGetFechas() {
      const payload = {
        organizacion: this.$store.getters.getAutenticacion.empresa,
        rol: this.idRol
      }
      SrvFechasRoles.getFechasRoles(payload).then(response => {
        const datos = response.data.roles
        if (response.status === 200) {
          if (Array.isArray(datos)) {
            datos.forEach(item => {
              this.dFechas.fechaIniLimit = item.fechaInicio
              this.dFechas.fechaFinLimit = item.fechaFinal
              this.dFechas.diasAntiguedad = item.diasAntiguedad
              this.dFechas.autoFiltro = (item.autoFiltro === 'S')
            })
          }
        }
      })
    },
    /*
     * Obtiene los datos del usuario y actualiza la parametrización
     */
    fgetDatosUsuario() {
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        getAvatarSN: 'N'
      }
      SrvUsers.datosUsuarioPortal(payload).then(response => {
        if (response.data && !response.data.errorMsg) {
          const datosUsuario = response.data
          // Actualizar parametrización del usuario
          
          this.setParametrizacionUsuario({
            consultaDocEstadoPedSN: datosUsuario.result[0].consultaDocEstadoPedSN || null,
            permiteCreaOCSN: datosUsuario.result[0].permiteCreaOCSN || null
          })
        }
        
      }).catch(error => {
        console.error('Error al obtener datos del usuario:', error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Informes/ShpInformes.vue